/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import layoutAPI from '@/api/layoutAPI.js';
import httpClient from '../../api/axios-httpclient';

export default {
	loadLayout: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: layoutAPI.getAPIUrl() + '/getlayoutconfig',
				params: payload
			},
			false,
			false
		);

		if (res.Success) {
			context.commit('updateLayout', res.Data);
		}

		return res;
	},
	insertLayout: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: layoutAPI.getAPIUrl() + '/save',
			data: payload
		});

		return res;
	},
	resetDefaultLayout: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: layoutAPI.getAPIUrl() + '/reset',
				params: payload
			},
			false,
			false
		);

		if (res.Success) {
			context.commit('resetLayout', payload.layoutId);
		}

		return res;
	}
};
